<template>
    <div class="rule-name-cell">
        <div
            ref="name"
            class="rule-name-cell__name"
            :title="initialReduce ? '' : name"
        >
            {{ ruleName }}
        </div>
    </div>
</template>

<script>
export default {
  name: 'RuleNameCell',
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      initialReduce: true,
      ruleName: this.name,
    };
  },
  watch: {
    name(newVal) {
      this.initialReduce = true;
      this.ruleName = newVal;
      this.$nextTick(this.reduceName);
    },
  },
  mounted() {
    this.reduceName();
  },
  methods: {
    reduceName() {
      /**
             * 可等待二分查找提高效率
             */
      // console.log(this.$refs.name.scrollHeight, this.$refs.name.offsetHeight);
      if (this.$refs.name.scrollHeight > this.$refs.name.offsetHeight) {
        if (this.initialReduce) {
          this.ruleName += '…';
          this.initialReduce = false;
        }
        if (this.ruleName.length > 1) {
          this.ruleName = `${this.ruleName.substr(0, this.ruleName.length - 2)}…`;
          this.$nextTick(this.reduceName);
        }
      }
    },
  },
};
</script>

<style lang="less">
@import '~@/common/common';

.rule-name-cell {
    &__name {
        // float: left;
        word-break: break-all;
        word-wrap: break-word;
        display: inline-block;
        vertical-align: middle;
        width: 104px;
        max-height: 40px;
        overflow-y: auto;
    }
}
</style>
